<div
  class="onboarding__card"
  [class.onboarding__card--disabled]="disabled"
  [class.onboarding__card--checked]="checked"
  (click)="goToUrl()"
>
  <div class="onboarding__card-icon">
    <img class="onboarding__card-icon-image" [src]="imageUrl" [alt]="title" />
  </div>
  <p class="onboarding__card-title">{{ title }}</p>
  <mat-icon
    class="onboarding__card-arrow-icon onboarding__card-arrow-icon-done"
    *ngIf="checked"
    >done</mat-icon
  >
  <mat-icon
    class="onboarding__card-arrow-icon onboarding__card-arrow-icon-arrow_forward"
    *ngIf="!checked"
    >arrow_forward</mat-icon
  >
</div>
